<template>
  <div class="logo-construction-content" id="identidade-visual-logo-construcao-da-logo" data-search-anchor>
    <div class="title-construction-wrapper">
      <h1 class="logo-construction-title-span">{{ logoConstructionTitleSpan }}</h1>
      <h1 class="logo-construction-title">{{ logoConstructionTitle }}</h1>
    </div>
    <div class="description-construction-wrapper">
      <p class="logo-construction-description">{{ logoConstructionDescription }}</p>
      <p class="logo-construction-description">{{ logoConstructionDescription1 }}</p>
    </div>
    <p class="logo-title-image">Construção</p>
    <div class="logo-construction-card-item" :style="{ backgroundImage: `url(${logoConstructionImageSrc})` }"></div>
    <div class="logo-construction-card-wrapper">
      <div class="logo-construction-text-container">
        <p class="title-image-bottom">Área de proteção</p>
        <p class="title-image-bottom" style="left:0.7rem">Tamanho mínimo</p>
      </div> 
      <div>        
        <div class="logo-construction-card-item-bottom" :style="{ backgroundImage: `url(${logoConstructionImageSrcBottom})` }"></div>
      </div>     
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class LogoConstructionSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logoConstructionTitleSpan(): string {
    return this.getElementTitle(3, 0)
  }

  get logoConstructionTitle(): string {
    return this.getElementText(3, 0)
  }

  get logoConstructionDescription(): string {
    return this.getElementText(3, 1)
  }

  get logoConstructionDescription1(): string {
    return this.getElementText(3, 2)
  }

  get logoConstructionImageSrc(): string {
    return this.getElementMedia(3, 3)
  }

  get logoConstructionImageSrcBottom(): string {
    return this.getElementMedia(3, 4)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-construction-content {
  display: grid;
  width: 100%;
  max-width: 1032px;
}

.title-construction-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.logo-construction-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.logo-construction-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin: 0;
  color: #000000;
}

.description-construction-wrapper {
  position: relative;  
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 0rem;
  justify-content: space-around;
  max-width: 1032px;
}

.logo-construction-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  max-width: 430px;
  margin: 0;
}

.logo-title-image {
  font-size: 20px;
  font-weight: 600;
  text-align: left;

  width: 187px;
  padding-top: 6.25rem;
  margin: 0;
}

.logo-construction-card-item {
  position: relative;
  bottom: 0;
  max-width: 1032px;
  width: 100%;
  height: 368px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.logo-construction-card-wrapper {    
  padding-top: 2rem;
}

.logo-construction-text-container {
  display: grid;  
  grid-template-columns: 50% 50%; 
  width: 1032px;  
}

.title-image-bottom {
  font-size: 20px;
  font-weight: 600; 

  position: relative;
  z-index: 1;
  background: #fff;
  width: 200px;
  margin: 0;
}

.logo-construction-card-item-bottom {
  position: relative;

  width: 1032px;
  height: 339px;  

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
